import { createApp } from "vue";
import { ApmVuePlugin } from '@elastic/apm-rum-vue'
import App from "./tpls/index.vue";
import 'vant/es/toast/style';
// 性能监控 
let lang = ''
let customArr = import.meta.env && import.meta.env.VITE_CUSTOM_ARR.split(",")
customArr.forEach(item => {
  if (item.includes("VITE_CUSTOM_LANG")) {
    lang = item.split("=")?.[1]
  }
});
const returnCountry = () => {
  if (lang == 'Yin') {
    return "https://apm-rum-sgp.inf.miui.com"
  } else if (lang == 'Xi') {
    return "https://apm-rum-eu.inf.miui.com"
  }
  // else if (lang == 'En') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Russian') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'French') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Italy') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Portugal') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'Turkish') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // } else if (lang == 'German') {
  //   return "https://apm-rum-eu.inf.miui.com"
  // }
}
const options = {
  /*
    * 合规要求，不同集群服务需上报到不同apm集群
    * 测试环境：https://apm-staging.inf.miui.com
    * 线上环境新加坡集群：https://apm-rum-sgp.inf.miui.com
    * 线上环境俄罗斯集群：https://apm-rum-ru.inf.miui.com
    * 线上环境印度集群：https://apm-rum-ind.inf.miui.com
    * 线上环境欧洲集群：https://apm-rum-eu.inf.miui.com
    */
  serverUrl: returnCountry(),
  // 如 cp-wuli-widget-h5
  serviceName: `cp-wuli-xiaomi-widget-can`,
  // 服务版本号，可以用git的commit id
  serviceVersion: '0.0.1',
  /*
   * 服务环境
   * 测试环境：staging
   * 预发环境：preview
   * 线上环境：production
   */
  environment: 'production',
  // 是否开启上报，建议本地开发环境不上报
  active: import.meta.env.MODE == "development" ? false : true,
}
const app = createApp(App);
// app.use(ApmVuePlugin, { config: options })
app.mount("#app");

// app.config.globalProperties.$apm?.addLabels?.({ group: 'global-miui-fe-cp' });
